import {LOCALE_ID , NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule , Routes} from '@angular/router';
import {SharedModule} from './core/modules/shared.module';
import {AppComponent} from './app.component';
import {FuseMainModule} from './main/main.module';
import {PagesModule} from './main/content/pages/pages.module';
import {PagesPepperModule} from './main/pages/pages.module';
import {FuseSplashScreenService} from './core/services/splash-screen.service';
import {FuseConfigService} from './core/services/config.service';
import {AuthService} from './core/services/auth.service';
import {FuseNavigationService} from './core/components/navigation/navigation.service';
import {TranslateLoader , TranslateModule , TranslateService} from '@ngx-translate/core';
import {AuthGuard} from './guards/auth.guard';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FormsModule , NG_VALIDATORS , ReactiveFormsModule} from '@angular/forms';
import {AppConfig} from './app.config';
import {checkEmailOnServer , emailValidator , numberValidator , websiteValidator} from './core/validators/validators';
import {PdfViewerModule} from 'ng2-pdf-viewer';

import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MaterialModule} from './core/modules/material.module';
import {RequestInterceptor} from './core/services/interceptor.service';
import {ChartsModule} from 'angular-bootstrap-md';
import localeDECH from '@angular/common/locales/de-CH';
import {registerLocaleData} from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import {NgxSpinnerModule} from 'ngx-spinner';
import {NgSelectModule} from '@ng-select/ng-select';
import { MatPaginatorIntl } from '@angular/material/paginator';
import {MatPaginationIntlService } from './core/services/matPaginatorIntlCroClass';
import {QuillModule} from 'ngx-quill';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ServerService } from './core/services/server.service';
import { MatListModule } from '@angular/material/list';
const appRoutes: Routes = [
  {
    path: '**' ,
    redirectTo: 'pages/event' ,
    pathMatch: 'full'
  }
];
export function createTranslateLoader (http: HttpClient) {
  return new TranslateHttpLoader(http , './assets/i18n/' , '.json');
}
registerLocaleData(localeDECH);
@NgModule({ declarations: [
        AppComponent
    ],
    exports: [],
    bootstrap: [
        AppComponent
    ],
  imports: [
    BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes),
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        FuseMainModule,
        PagesModule,
        PagesPepperModule,
        ReactiveFormsModule,
        PdfViewerModule,
        TooltipModule.forRoot(),
        FormsModule,
        BrowserAnimationsModule,
        MaterialModule,
        ChartsModule,
        NgxSpinnerModule,
        NgSelectModule,
        ToastrModule.forRoot({
            timeOut: 6000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),
        MatListModule,
        QuillModule.forRoot(),
        EditorModule
  ],
  providers: [
        FuseSplashScreenService,
        FuseConfigService,
        AuthService,
        FuseNavigationService,
        AuthGuard,
        AppConfig,
        ServerService,
        { provide: LOCALE_ID, useValue: 'de-CH' },
        { provide: NG_VALIDATORS, useValue: numberValidator, multi: true },
        { provide: NG_VALIDATORS, useValue: websiteValidator, multi: true },
        { provide: NG_VALIDATORS, useValue: emailValidator, multi: true },
        { provide: NG_VALIDATORS, useValue: checkEmailOnServer, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true,
        },
        {
            provide: MatPaginatorIntl,
            useFactory: (translate) => {
                const service = new MatPaginationIntlService();
                service.injectTranslateService(translate);
                return service;
            },
            deps: [TranslateService]
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
